<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        :todo-list.sync="todoList"
        show-to-do
        @task="taskFun"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.depotName"
              placeholder="请输入仓库名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.schemeNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.outdepotType"
              placeholder="请选择出库类型"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.status"
              placeholder="请选择状态"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @view="viewFun(arguments)"
        @delete="deleteFun(arguments)"
        @check="checkFun(arguments)"
        @unCheck="unCheckFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 新增 修改-->
    <add-edit-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />

    <!-- 修改调拨出库 -->
    <add-edit-task-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditTaskVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-title="dialogViewTitle"
      :dialog-visible.sync="dialogViewVisible"
      :master-table-key="masterList.tableKey"
    />

    <!-- 调拨出库待办列表 -->
    <task-list-dialog
      :dialog-visible.sync="dialogTaskVisible"
      :dialog-title="dialogTaskTitle"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 新增 修改
import addEditDialog from './components/addEditDialog'
// 修改调拨出库
import addEditTaskDialog from './components/addEditTaskDialog'
// 查看
import ViewDialog from './components/viewDialog'
// 调拨出库待办列表
import taskListDialog from './components/taskListDialog'
// 导出batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 数据请求
import { loadOutdepotBillListDataApi, loadOutdepotBillExportDataApi, saveOrUpdateOutdepotBillApi } from '@/api/outdepotBill'
import { countTodoMaterialsDemandApi } from '@/api/materialsDemandDetail'

export default {
  name: 'OutDepotBill',
  components: {
    CustomTable,
    TableOperation,
    addEditDialog,
    addEditTaskDialog,
    ViewDialog,
    taskListDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'out_depot_bill_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['outdepot_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['outdepot_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['outdepot_check'],
            prop: 'check',
            label: '复核',
            method: 'check'
          },
          {
            permissionSigns: ['outdepot_uncheck'],
            prop: 'unCheck',
            label: '反复核',
            method: 'unCheck'
          },
          {
            permissionSigns: ['outdepot_del'],
            prop: 'delete',
            label: '作废',
            method: 'delete'
          },
          {
            permissionSigns: ['outdepot_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['outdepot_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            depotName: '',
            schemeNo: '',
            outdepotType: '',
            status: ''
          }
        },
        notPaging: true
      },
      // 待办
      todoList: [
        {
          permissionSigns: ['outdepot_add'],
          label: '待制定调拨出库单',
          method: 'task',
          count: 0
        }
      ],
      typeOptions: [
        { value: 1, label: '终端维护' },
        { value: 3, label: '品牌推广' },
        { value: 4, label: '品鉴活动' },
        { value: 5, label: 'QDYX1' },
        { value: 13, label: '调拨出库' },
        { value: 6, label: '退库' },
        { value: 7, label: 'QDYX2' },
        { value: 2, label: '其他' }
      ],
      statusOptions: [{ value: 1, label: '制单' }, { value: 2, label: '复核' }],
      id: null, // 选中的单据ID
      eventType: '',
      dialogAddEditTitle: '',
      dialogAddEditVisible: false,
      dialogAddEditTaskVisible: false,
      dialogViewTitle: '查看出库单',
      dialogViewVisible: false,
      dialogTaskVisible: false,
      dialogTaskTitle: ''
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'id', filterColumn: 'bill.id', label: '单据编号', width: 110 },
      { prop: 'depotName', label: '仓库名称', filterColumn: 'bill.depot_name', width: 120 },
      { prop: 'outdepotDateStr', label: '出库时间', filterColumn: 'bill.outdepot_date', width: 120 },
      { prop: 'outdepotTypeStr', label: '出库类型', filterColumn: 'bill.outdepot_type', filterValue: 'outdepotType', filterArray: this.typeOptions, width: 120 },
      { prop: 'schemeNo', label: '方案编号', filterColumn: 'ifnull(s.project_no, \'\')', width: 180 },
      { prop: 'schemeName', label: '方案名称', filterColumn: 'ifnull(s.name, \'\')', width: 400 },
      { prop: 'operater', label: '经办人', filterColumn: 'bill.operater', width: 120 },
      { prop: 'receiver', label: '物料使用人', filterColumn: 'bill.receiver', width: 120 },
      { prop: 'statusStr', label: '状态', filterColumn: 'status', filterValue: 'status', filterArray: this.statusOptions, width: 100 },
      { prop: 'remark', filterColumn: 'bill.remark', label: '备注' },
      { prop: 'operatorName', filterColumn: 'bill.operator_name', label: '操作人', width: 120 },
      { prop: 'operationTimeStr', filterColumn: 'bill.operation_time', label: '操作时间', width: 150, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = false
      loadOutdepotBillListDataApi({ condition: JSON.stringify(this.masterList.tableQuery) }).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data || []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal || 0
      }).catch()
      this.getTodoCount()
    },
    // 获取待办任务数量
    getTodoCount () {
      // 待制定调拨物料出库单
      countTodoMaterialsDemandApi({ type: 'transfer' }).then(res => {
        this.todoList[0].count = res.data || 0
      })
    },
    // 代办
    taskFun () {
      this.dialogTaskTitle = '待制定调拨出库单'
      this.dialogTaskVisible = !this.dialogTaskVisible
    },
    // 新增
    addFun () {
      this.eventType = 'add'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '新增出库单'
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要修改的出库单', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        this.$message({ message: '出库单不是制单状态，不能修改', type: 'warning' })
        return
      }

      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogAddEditTitle = '修改出库单'
      if (args[0].outdepotType === 13) {
        this.dialogAddEditTaskVisible = !this.dialogAddEditTaskVisible
      } else {
        this.dialogAddEditVisible = !this.dialogAddEditVisible
      }
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要查看的出库单', type: 'warning' })
        return
      }
      this.id = args[0].id
      this.dialogViewVisible = !this.dialogViewVisible
    },
    // 作废
    deleteFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要作废的出库单', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        this.$message({ message: '出库单不是制单状态，不能作废', type: 'warning' })
        return
      }
      this.$confirm('是否确定作废该出库单？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        saveOrUpdateOutdepotBillApi({ id: args[0].id, status: 0, isDel: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 复核
    checkFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要复核的出库单', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        this.$message({ message: '出库单不是制单状态，不能复核', type: 'warning' })
        return
      }
      this.$confirm('是否确定复核该出库单？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        saveOrUpdateOutdepotBillApi({ id: args[0].id, status: 2, operateType: 1, isCheck: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 反复核
    unCheckFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要反复核的出库单', type: 'warning' })
        return
      } else if (args[0].status !== 2) {
        this.$message({ message: '出库单不是复核状态，不能反复核', type: 'warning' })
        return
      }

      this.$confirm('是否确定反复核该出库单？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        saveOrUpdateOutdepotBillApi({ id: args[0].id, status: 1, operateType: 0, isCheck: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadOutdepotBillExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
